<template>
  <v-row class="pa-5" v-if="exercise">
    <v-col cols="12">
      <h2>Stakeholder Summary</h2>
    </v-col>
    <v-col cols="10" offset="1">
      <v-row>
        <v-col cols="6">
          <v-card light :color="$t(`${lang}.color-1`)">
            <v-card-text>
              <results-items
                v-model="flatten.q1"
                name="matrix.q1"
                :title="$t(`${lang}.col1`)"
              ></results-items>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card light :color="$t(`${lang}.color-2`)">
            <v-card-text>
              <results-items
                v-model="flatten.q2"
                name="matrix.q2"
                :title="$t(`${lang}.col2`)"
              ></results-items> </v-card-text
          ></v-card>
        </v-col>
        <v-col cols="6">
          <v-card light :color="$t(`${lang}.color-3`)">
            <v-card-text>
              <results-items
                v-model="flatten.q3"
                name="matrix.q3"
                :title="$t(`${lang}.col3`)"
              ></results-items> </v-card-text
          ></v-card>
        </v-col>
        <v-col cols="6">
          <v-card light :color="$t(`${lang}.color-4`)">
            <v-card-text>
              <results-items
                v-model="flatten.q4"
                name="matrix.q4"
                :title="$t(`${lang}.col4`)"
              ></results-items> </v-card-text
          ></v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import ResultsItems from "./ResultsItems";

export default {
  name: "ResultsUser",
  data() {
    return {
      doc: null,
      exercise: null,
      results: {
        q1: [],
        q2: [],
        q3: [],
        q4: [],
      },
      flatten: {
        q1: [],
        q2: [],
        q3: [],
        q4: [],
      },
      dialog: false,
    };
  },
  props: {
    uid: String,
    id: String,
    model: String,
    lang: String,
  },
  components: {
    ResultsItems,
  },
  mounted() {
    this.getExercise();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getExercise() {
      console.log("get exercise");
      let ref = fb[this.model].where("pid", "==", this.id);
      ref.onSnapshot((querySnapshot) => {
        querySnapshot.forEach((docs) => {
          let post = docs.data();
          this.getResults(post.doc);
        });
        this.exercise = true;
      });
    },
    getResults(doc) {
      this.pushToArray(doc.matrix.q1, "q1");
      this.pushToArray(doc.matrix.q2, "q2");
      this.pushToArray(doc.matrix.q3, "q3");
      this.pushToArray(doc.matrix.q4, "q4");
      this.flatten.q1 = this.getSubGroup(this.results.q1);
      this.flatten.q2 = this.getSubGroup(this.results.q2);
      this.flatten.q3 = this.getSubGroup(this.results.q3);
      this.flatten.q4 = this.getSubGroup(this.results.q4);
    },
    pushToArray(arr, model) {
      if (arr || arr.length > 0 || arr != undefined) {
        arr.forEach((y) => {
          this.results[model].push(y);
        });
      }
    },
    getSubGroup(group) {
      let items = [];
      let distribution = group.reduce(
        (acum, cur) =>
          Object.assign(acum, {
            [`<h4>${cur.title}</h4><p>${
              cur.description ? cur.description : ""
            }</p>`]:
              (acum[
                `<h4>${cur.title}</h4><p>${
                  cur.description ? cur.description : ""
                }</p>`
              ] |
                0) +
              1,
          }),
        {}
      );
      for (var element in distribution) {
        items.push({ el: element, count: distribution[element] });
      }
      return items;
    },
  },
};
</script>
